import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';

// Temporarily hides the "Elevate Your Team" eBook banner site-wide; set to true to re-enable.
const BANNER_ENABLED: boolean = false;

@Component({
  selector: 'app-news-banner',
  templateUrl: './news-banner.component.html',
  styleUrls: ['./news-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewsBannerComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  // Banner is shown everywhere EXCEPT dashboard, landing, embed, survey routes.
  // Driven off router events so the template doesn't fire four getters every
  // CD tick (this component is always mounted on the site shell).
  readonly bannerVisible = signal(false);
  open = true;

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.bannerVisible.set(this.computeVisibility());
      });
  }

  closeBanner(): void {
    this.open = false;
  }

  private computeVisibility(): boolean {
    if (!BANNER_ENABLED) {
      return false;
    }
    const url = this.router.url;
    return !(
      url.startsWith('/dash') ||
      url.startsWith('/landing') ||
      url.startsWith('/embed') ||
      url.startsWith('/survey')
    );
  }
}
